import Vue from 'vue';
import {
  Button,
  Cell, 
  CellGroup,
  Icon,
  Toast,
  Field,
  Form,
  Uploader,
  DropdownMenu,
  DropdownItem,
  NoticeBar,
  NavBar,
  List,
  PullRefresh,
  Checkbox, 
  CheckboxGroup,
  RadioGroup,
  Radio,
  Picker,
  Popup,
  DatetimePicker,
  Swipe, SwipeItem,
  Tab, Tabs,
  Sticky,Loading,Tag,
  Divider, Rate,
  Empty,
  Overlay,
  Dialog,
  Col, Row,
  Search
} from 'vant';

Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Field);
Vue.use(Form);
Vue.use(Uploader);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(NoticeBar);
Vue.use(NavBar);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Sticky);
Vue.use(Loading);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Rate);
Vue.use(Empty);
Vue.use(Overlay);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(Search);
